import requests from './httpService';

const TripadvancePaymentServices = {
	tripadvancepaymentRequestList: async (body) => {
		return requests.post(`/tripAdvance/payment-list`, body);
	},
	updatetripadvancepayment: async (id, body) => {
		return requests.put(`/tripAdvance/tripadvance-payment/${id}`, body);
	},
	updatetripadvanceReadypayment: async (body) => {
		return requests.put(`/tripAdvance/tripadvance-payment-bulk`, body);
	},
	adjustedTripAdvance: async (body) => {
		return requests.put(`/tripAdvance/adjust-outstanding`, body);
	},
};

export default TripadvancePaymentServices;
